module.exports = __webpack_public_path__ + "static/media/elevated3-mobile.8ef20359.webp";